import { HTTPService } from 'fides-angularjs-components/src/fts-services/fts-http-service';
import { currencies } from './arsweb/RoutingPaths';

export class CurrencyService {
    constructor(ftsMainDependencies) {
        this.service = new HTTPService(ftsMainDependencies);
    }

    async getCurrencies() {
        return this.service.useGetHandler(currencies);
    }
}
